import * as THREE from 'three';

/**
 * A teleport point of Bekijken mode (ADR-058): a blue disc lying on the floor, pressed like a lectern
 * button (it is one of the lectern's extra pressables) and lit while a ray is on it. Pressing it is the
 * caller's: a fade teleport to the point.
 */
export const MARKER = {
  radius: 0.35,
  lift: 0.02,
  colour: 0x1e6fd9,
  idle: 0.45,
  hovered: 0.9,
} as const;

export class TeleportMarker {
  readonly mesh: THREE.Mesh<THREE.CircleGeometry, THREE.MeshBasicMaterial>;

  constructor(
    at: readonly [number, number],
    readonly onSelect: () => void,
  ) {
    this.mesh = new THREE.Mesh(
      new THREE.CircleGeometry(MARKER.radius, 32),
      new THREE.MeshBasicMaterial({
        color: MARKER.colour,
        transparent: true,
        opacity: MARKER.idle,
        depthWrite: false,
      }),
    );
    this.mesh.rotation.x = -Math.PI / 2;
    this.mesh.position.set(at[0], MARKER.lift, at[1]);
    this.mesh.renderOrder = 5;
    this.mesh.name = 'teleport-point';
    this.mesh.userData['button'] = this;
    this.mesh.userData['floor'] = true;
  }

  set hovered(on: boolean) {
    this.mesh.material.opacity = on ? MARKER.hovered : MARKER.idle;
  }

  get hovered(): boolean {
    return this.mesh.material.opacity === MARKER.hovered;
  }

  dispose(): void {
    this.mesh.geometry.dispose();
    this.mesh.material.dispose();
    this.mesh.removeFromParent();
  }
}
